import { fromByteArray, toByteArray } from 'base64-js';

export function toBase64(data: Uint8Array | Iterable<number>): string {
    if (!(data instanceof Uint8Array)) data = new Uint8Array(data);
    return fromByteArray(data as Uint8Array);
}

export function fromBase64(base64: string): Uint8Array {
    return toByteArray(base64);
}

export function toURLSafeBase64(base64String: string): string;
export function toURLSafeBase64(bytes: Uint8Array | Iterable<number>): string;
export function toURLSafeBase64(
    array: Uint8Array | Iterable<number> | string
): string {
    const base64String = typeof array === 'string' ? array : toBase64(array);

    return base64String
        .replaceAll('+', '-')
        .replaceAll('/', '_')
        .replaceAll('=', '');
}
